<template>
  <Select v-model="innerArr" multiple style="width:156px" @on-change="changeSel">
    <div class="d" slot="placeholderLi">ddd</div>
    <Option v-for="opt in options" :value="opt.value" :key="opt.value">{{ opt.name }}</Option>
  </Select>
</template>
<script>
export default {
  data() {
    return {
      innerArr: []
    }
  },
  props: {
    id: String,
    value: Array,
    options: Array
  },
  watch: {
    value: {
      handler: function() {
        this.innerArr = [].concat(this.value)
      },
      deep: true
    }
  },
  methods: {
    changeSel(arr) {
      this.$emit('change', this.id, arr)
    }
  }
}
</script>
